module.exports = __webpack_public_path__ + "img/gyroscope.5405cb6d.svg";